import React, { useId } from 'react';
import styles from './Style.module.css';

export const ServiceCategoryNav = ({ categories, activeCategory, setCategoryRef, onCategoryClick }) => {
  const listId = useId();
  const activeIndex = categories.findIndex(category => category.id === activeCategory);
  const canGoPrevious = activeIndex > 0;
  const canGoNext = categories.length > 1 && activeIndex < categories.length - 1;

  const scrollCategories = (direction) => {
    // Arrows step the selection; selecting a category scrolls the page to its
    // section and centers its chip in this bar (handled by the parent).
    if (direction < 0 ? !canGoPrevious : !canGoNext) return;
    const next = categories[activeIndex + direction];
    if (next) onCategoryClick(next.id);
  };

  return (
    <nav className={`${styles.categoryNav} container-md`} aria-label="Service categories">
      <div
        id={listId}
        className={`${styles.categoryList} space-x hide-scrollbar`}
      >
        {categories.map(category => (
          <button
            key={category.id}
            type="button"
            ref={setCategoryRef(category.id)}
            className={`${styles.categoryBtn}${activeCategory === category.id ? ` ${styles.isActive}` : ''}`}
            onClick={() => onCategoryClick(category.id)}
            title={category.name}
            aria-label={category.name}
            aria-current={activeCategory === category.id ? 'true' : undefined}
          >
            {category.name}
          </button>
        ))}
      </div>
        {canGoPrevious && (
          <div className={`${styles.scrollEdge} ${styles.leftEdge}`}>
            <button type="button" className={`${styles.scrollButton} ${styles.scrollButtonPrev}`}
              aria-label="Scroll service categories left" title="Previous service categories"
              aria-controls={listId} onClick={() => scrollCategories(-1)} />
          </div>
        )}
        {canGoNext && (
          <div className={`${styles.scrollEdge} ${styles.rightEdge}`}>
            <button type="button" className={`${styles.scrollButton} ${styles.scrollButtonNext}`}
              aria-label="Scroll service categories right" title="More service categories"
              aria-controls={listId} onClick={() => scrollCategories(1)} />
          </div>
        )}
    </nav>
  );
};
